<template>
    <b-tab :title="'day ' + id" :active="id == '1' ? true : false">
        {{ content }}
    </b-tab>
</template>

<script>
export default {
    props: [
        'id',
        'content'
    ],
}
</script>

<style>

</style>
